<template>
  <v-dialog max-width="450px" v-model="c_licenseDialogVisible">
    <template v-slot:activator="{c_licenseDialogVisible}"></template> <!-- eslint-disable-line -->
      <v-card>
        <v-card-title>MIT License</v-card-title>
        <v-card-subtitle>
          Copyright © 2016-2021 Vuetify<br>
          Copyright (c) 2014-present Matt Zabriskie<br>
          Copyright (c) 2014-2022 Denis Pushkarev<br>
          Copyright (c) 2013 Dirk Bonhomme &lt;dirk@bytelogic.be&gt;<br>
          Copyright (c) 2010 Elijah Insua<br>
          Copyright © 2010-2022 three.js authors<br>
          Copyright (c) 2013-present, Yuxi (Evan) You<br>
          Copyright (c) 2016 kazuya kawaguchi<br>
          Copyright (c) 2017 James Churchard<br>
          Copyright (c) 2013-present Evan You<br>
          Copyright (c) 2016-2017 Mickael Bouchaud<br>
          Copyright (c) 2018 Muhridin Ibragimov<br>
          Copyright (c) 2016-2020 John Jeremy Leider<br>
          Copyright (c) 2015-present Evan You<br>
          Copyright (c) Robin van der Vleuten &lt;robin@webstronauts.co&gt;
        </v-card-subtitle>
        <v-card-text>
          Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), 
          to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, 
          publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, 
          subject to the following conditions:
          <br><br>
          The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
          <br><br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO 
          THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF 
          CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER 
          DEALINGS IN THE SOFTWARE.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>Amazon Software License</v-card-title>
          <v-card-text>
          This Amazon Software License (“License”) governs your use, reproduction, and distribution of the accompanying software as specified below.
          <br><br>
          1. Definitions
          <br>
          “Licensor” means any person or entity that distributes its Work.<br>
          “Software” means the original work of authorship made available under this License.<br>
          “Work” means the Software and any additions to or derivative works of the Software that are made available under this License.<br>
          The terms “reproduce,” “reproduction,” “derivative works,” and “distribution” have the meaning as provided under U.S. copyright law; provided, however, that for the purposes of this License, derivative works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work.
          Works, including the Software, are “made available” under this License by including in or with the Work either (a) a copyright notice referencing the applicability of this License to the Work, or (b) a copy of this License.
          <br><br>
          2. License Grants<br>
          2.1 Copyright Grant. <br>
          Subject to the terms and conditions of this License, each Licensor grants to you a perpetual, worldwide, non-exclusive, royalty-free, copyright license to reproduce, prepare derivative works of, publicly display, publicly perform, sublicense and distribute its Work and any resulting derivative works in any form.<br>
          2.2 Patent Grant.<br>
           Subject to the terms and conditions of this License, each Licensor grants to you a perpetual, worldwide, non-exclusive, royalty-free patent license to make, have made, use, sell, offer for sale, import, and otherwise transfer its Work, in whole or in part. The foregoing license applies only to the patent claims licensable by Licensor that would be infringed by Licensor’s Work (or portion thereof) individually and excluding any combinations with any other materials or technology.
          <br><br>
          3. Limitations<br>
          3.1 Redistribution.<br>
           You may reproduce or distribute the Work only if (a) you do so under this License, (b) you include a complete copy of this License with your distribution, and (c) you retain without modification any copyright, patent, trademark, or attribution notices that are present in the Work.<br>
          3.2 Derivative Works.<br>
           You may specify that additional or different terms apply to the use, reproduction, and distribution of your derivative works of the Work (“Your Terms”) only if (a) Your Terms provide that the use limitation in Section 3.3 applies to your derivative works, and (b) you identify the specific derivative works that are subject to Your Terms. Notwithstanding Your Terms, this License (including the redistribution requirements in Section 3.1) will continue to apply to the Work itself.<br>
          3.3 Use Limitation.<br>
           The Work and any derivative works thereof only may be used or intended for use with the web services, computing platforms or applications provided by Amazon.com, Inc. or its affiliates, including Amazon Web Services, Inc.<br>
          3.4 Patent Claims. <br>
          If you bring or threaten to bring a patent claim against any Licensor (including any claim, cross-claim or counterclaim in a lawsuit) to enforce any patents that you allege are infringed by any Work, then your rights under this License from such Licensor (including the grants in Sections 2.1 and 2.2) will terminate immediately.<br>
          3.5 Trademarks.<br>
           This License does not grant any rights to use any Licensor’s or its affiliates’ names, logos, or trademarks, except as necessary to reproduce the notices described in this License.<br>
          3.6 Termination.<br>
           If you violate any term of this License, then your rights under this License (including the grants in Sections 2.1 and 2.2) will terminate immediately.
          <br><br>
          4. Disclaimer of Warranty.<br>
          THE WORK IS PROVIDED “AS IS” WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES OR CONDITIONS OF M ERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE OR NON-INFRINGEMENT. YOU BEAR THE RISK OF UNDERTAKING ANY ACTIVITIES UNDER THIS LICENSE. SOME STATES’ CONSUMER LAWS DO NOT ALLOW EXCLUSION OF AN IMPLIED WARRANTY, SO THIS DISCLAIMER MAY NOT APPLY TO YOU.
          <br><br>
          5. Limitation of Liability.<br>
          EXCEPT AS PROHIBITED BY APPLICABLE LAW, IN NO EVENT AND UNDER NO LEGAL THEORY, WHETHER IN TORT (INCLUDING NEGLIGENCE), CONTRACT, OR OTHERWISE SHALL ANY LICENSOR BE LIABLE TO YOU FOR DAMAGES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR RELATED TO THIS LICENSE, THE USE OR INABILITY TO USE THE WORK (INCLUDING BUT NOT LIMITED TO LOSS OF GOODWILL, BUSINESS INTERRUPTION, LOST PROFITS OR DATA, COMPUTER FAILURE OR MALFUNCTION, OR ANY OTHER COMM ERCIAL DAMAGES OR LOSSES), EVEN IF THE LICENSOR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          <br><br>
          Effective Date – April 18, 2008 © 2008 Amazon.com, Inc. or its affiliates. All rights reserved.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title>Apache License</v-card-title>
        <v-card-subtitle> 
          2.0, January 2004<br>
          http://www.apache.org/licenses/
        </v-card-subtitle>
        <v-card-text>
          TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
          <br><br>
          1. Definitions.
          <br>
          "License" shall mean the terms and conditions for use, reproduction,
          and distribution as defined by Sections 1 through 9 of this document.<br>

          "Licensor" shall mean the copyright owner or entity authorized by
          the copyright owner that is granting the License.<br>
          
          "Legal Entity" shall mean the union of the acting entity and all
          other entities that control, are controlled by, or are under common
          control with that entity. For the purposes of this definition,<br>
          
          "control" means (i) the power, direct or indirect, to cause the
          direction or management of such entity, whether by contract or
          otherwise, or (ii) ownership of fifty percent (50%) or more of the
          outstanding shares, or (iii) beneficial ownership of such entity.<br>
          
          "You" (or "Your") shall mean an individual or Legal Entity
          exercising permissions granted by this License.<br>
          
          "Source" form shall mean the preferred form for making modifications,
          including but not limited to software source code, documentation
          source, and configuration files.<br>
          
          "Object" form shall mean any form resulting from mechanical
          transformation or translation of a Source form, including but
          not limited to compiled object code, generated documentation,
          and conversions to other media types.<br>
          
          "Work" shall mean the work of authorship, whether in Source or
          Object form, made available under the License, as indicated by a
          copyright notice that is included in or attached to the work
          (an example is provided in the Appendix below).<br>
          "Derivative Works" shall mean any work, whether in Source or Object
          form, that is based on (or derived from) the Work and for which the
          editorial revisions, annotations, elaborations, or other modifications
          represent, as a whole, an original work of authorship. For the purposes
          of this License, Derivative Works shall not include works that remain
          separable from, or merely link (or bind by name) to the interfaces of,
          the Work and Derivative Works thereof.<br>
          
          "Contribution" shall mean any work of authorship, including
          the original version of the Work and any modifications or additions
          to that Work or Derivative Works thereof, that is intentionally
          submitted to Licensor for inclusion in the Work by the copyright owner
          or by an individual or Legal Entity authorized to submit on behalf of
          the copyright owner. For the purposes of this definition, "submitted"
          means any form of electronic, verbal, or written communication sent
          to the Licensor or its representatives, including but not limited to
          communication on electronic mailing lists, source code control systems,
          and issue tracking systems that are managed by, or on behalf of, the
          Licensor for the purpose of discussing and improving the Work, but
          excluding communication that is conspicuously marked or otherwise
          designated in writing by the copyright owner as "Not a Contribution."<br>
          
          "Contributor" shall mean Licensor and any individual or Legal Entity
          on behalf of whom a Contribution has been received by Licensor and
          subsequently incorporated within the Work.<br>
          <br>
          
          2. Grant of Copyright License. Subject to the terms and conditions of
              this License, each Contributor hereby grants to You a perpetual,
              worldwide, non-exclusive, no-charge, royalty-free, irrevocable
              copyright license to reproduce, prepare Derivative Works of,
              publicly display, publicly perform, sublicense, and distribute the
              Work and such Derivative Works in Source or Object form.<br>
          <br>
          3. Grant of Patent License. Subject to the terms and conditions of
              this License, each Contributor hereby grants to You a perpetual,
              worldwide, non-exclusive, no-charge, royalty-free, irrevocable
              (except as stated in this section) patent license to make, have made,
              use, offer to sell, sell, import, and otherwise transfer the Work,
              where such license applies only to those patent claims licensable
              by such Contributor that are necessarily infringed by their
              Contribution(s) alone or by combination of their Contribution(s)
              with the Work to which such Contribution(s) was submitted. If You
              institute patent litigation against any entity (including a
              cross-claim or counterclaim in a lawsuit) alleging that the Work
              or a Contribution incorporated within the Work constitutes direct
              or contributory patent infringement, then any patent licenses
              granted to You under this License for that Work shall terminate
              as of the date such litigation is filed.<br>
          <br>
          4. Redistribution. You may reproduce and distribute copies of the
              Work or Derivative Works thereof in any medium, with or without
              modifications, and in Source or Object form, provided that You
              meet the following conditions:<br>
              (a) You must give any other recipients of the Work or
                  Derivative Works a copy of this License; and<br>

              (b) You must cause any modified files to carry prominent notices
                  stating that You changed the files; and<br>

              (c) You must retain, in the Source form of any Derivative Works
                  that You distribute, all copyright, patent, trademark, and
                  attribution notices from the Source form of the Work,
                  excluding those notices that do not pertain to any part of
                  the Derivative Works; and<br>

              (d) If the Work includes a "NOTICE" text file as part of its
                  distribution, then any Derivative Works that You distribute must
                  include a readable copy of the attribution notices contained
                  within such NOTICE file, excluding those notices that do not
                  pertain to any part of the Derivative Works, in at least one
                  of the following places: within a NOTICE text file distributed
                  as part of the Derivative Works; within the Source form or
                  documentation, if provided along with the Derivative Works; or,
                  within a display generated by the Derivative Works, if and
                  wherever such third-party notices normally appear. The contents
                  of the NOTICE file are for informational purposes only and
                  do not modify the License. You may add Your own attribution
                  notices within Derivative Works that You distribute, alongside
                  or as an addendum to the NOTICE text from the Work, provided
                  that such additional attribution notices cannot be construed
                  as modifying the License.<br>

                  You may add Your own copyright statement to Your modifications and
                  may provide additional or different license terms and conditions
                  for use, reproduction, or distribution of Your modifications, or
                  for any such Derivative Works as a whole, provided Your use,
                  reproduction, and distribution of the Work otherwise complies with
                  the conditions stated in this License.<br>
                  <br>

                  5. Submission of Contributions. Unless You explicitly state otherwise,
                      any Contribution intentionally submitted for inclusion in the Work
                      by You to the Licensor shall be under the terms and conditions of
                      this License, without any additional terms or conditions.
                      Notwithstanding the above, nothing herein shall supersede or modify
                      the terms of any separate license agreement you may have executed
                      with Licensor regarding such Contributions.<br>
                  <br>
                  6. Trademarks. This License does not grant permission to use the trade
                      names, trademarks, service marks, or product names of the Licensor,
                      except as required for reasonable and customary use in describing the
                      origin of the Work and reproducing the content of the NOTICE file.<br>
                  <br>
                  7. Disclaimer of Warranty. Unless required by applicable law or
                      agreed to in writing, Licensor provides the Work (and each
                      Contributor provides its Contributions) on an "AS IS" BASIS,
                      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
                      implied, including, without limitation, any warranties or conditions
                      of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
                      PARTICULAR PURPOSE. You are solely responsible for determining the
                      appropriateness of using or redistributing the Work and assume any
                      risks associated with Your exercise of permissions under this License.<br>
                  <br>
                  8. Limitation of Liability. In no event and under no legal theory,
                      whether in tort (including negligence), contract, or otherwise,
                      unless required by applicable law (such as deliberate and grossly
                      negligent acts) or agreed to in writing, shall any Contributor be
                      liable to You for damages, including any direct, indirect, special,
                      incidental, or consequential damages of any character arising as a
                      result of this License or out of the use or inability to use the
                      Work (including but not limited to damages for loss of goodwill,
                      work stoppage, computer failure or malfunction, or any and all
                      other commercial damages or losses), even if such Contributor
                      has been advised of the possibility of such damages.<br>
                  <br>
                  9. Accepting Warranty or Additional Liability. While redistributing
                      the Work or Derivative Works thereof, You may choose to offer,
                      and charge a fee for, acceptance of support, warranty, indemnity,
                      or other liability obligations and/or rights consistent with this
                      License. However, in accepting such obligations, You may act only
                      on Your own behalf and on Your sole responsibility, not on behalf
                      of any other Contributor, and only if You agree to indemnify,
                      defend, and hold each Contributor harmless for any liability
                      incurred by, or claims asserted against, such Contributor by reason
                      of your accepting any such warranty or additional liability.<br>
                  <br>
                  END OF TERMS AND CONDITIONS<br>
                  <br>
                  APPENDIX: How to apply the Apache License to your work.<br>
                      To apply the Apache License to your work, attach the following
                      boilerplate notice, with the fields enclosed by brackets "[]"
                      replaced with your own identifying information. (Don't include
                      the brackets!)  The text should be enclosed in the appropriate
                      comment syntax for the file format. We also recommend that a
                      file or class name and description of purpose be included on the
                      same "printed page" as the copyright notice for easier
                      identification within third-party archives.<br>
                  <br>
                  Copyright 2012-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.<br>
                  <br>
                  Licensed under the Apache License, Version 2.0 (the "License");
                  you may not use this file except in compliance with the License.
                  You may obtain a copy of the License at<br>

                      http://www.apache.org/licenses/LICENSE-2.0<br>

                  Unless required by applicable law or agreed to in writing, software
                  distributed under the License is distributed on an "AS IS" BASIS,
                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                  See the License for the specific language governing permissions and
                  limitations under the License.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title>BSD 2-Clause License</v-card-title>
        <v-card-subtitle>
          Copyright (c) 2010-2022, Vladimir Agafonkin<br>
          Copyright (c) 2010-2011, CloudMade<br>
          All rights reserved.
        </v-card-subtitle>
        <v-card-text>
          Redistribution and use in source and binary forms, with or without
          modification, are permitted provided that the following conditions are met:
          <br><br>
          1. Redistributions of source code must retain the above copyright notice, this
            list of conditions and the following disclaimer.
          <br><br>
          2. Redistributions in binary form must reproduce the above copyright notice,
            this list of conditions and the following disclaimer in the documentation
            and/or other materials provided with the distribution.
          <br><br>
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
          AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
          IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
          DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
          FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
          DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
          SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
          CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
          OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
          OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    licenseDialogVisible: { type: Boolean },
  },
  data() {
    return {

    }
  },
  computed: {
    c_licenseDialogVisible: {
      get() {
          return this.licenseDialogVisible
      },
      set(val) {
        this.$emit('license-dialog-visible', val)
      }
    }
  }
}
</script>

<style>

</style>